import React from "react";
import Entity from "../../components/Entity";
import { PROVINCES, MAJOR_GROUPS } from "../../Constants";

function Banner() {
  return (
    <Entity
      title={(e) => e.name || "New Banner"}
      formShema={{
        fields: [
          { name: "Name",        propertyName: "name",       type: "input",        col: 6 },
          { name: "Province",    propertyName: "provinces",  type: "select",       options: PROVINCES, isMulti: true, col: 4 },
          { name: "Major Group", propertyName: "majorGroup", type: "nativeSelect", options: MAJOR_GROUPS, col: 2 },
        ],
      }}
    />
  );
}

export default Banner;
